// 沒有記住語系的新訪客、以及指定了本站沒有的語系時，一律用這個語系
export const DEFAULT_LANG = 'en-US';
// 本站有完整翻譯、可切換的語系（順序即語言選單順序，須與 LanguageSelector 的 LanguageObject 一致）
export const SUPPORTED_LANGS = ['en-US', 'zh-CN', 'zh-TW', 'ja-JP', 'ms-MY'];
// 記住使用者語系的 localStorage key
export const LANG_STORAGE_KEY = 'i18n';
// 網址上指定顯示語系的參數（多語搜尋連結、平台 iframe 嵌入都用它）
export const LANG_PARAM = 'lang';
// 平台以 iframe 嵌入本站頁面時帶的參數
export const EMBEDDED_PARAM = 'embedded';
// 自訂選單欄位／資料 API 必帶的選單 id 標頭（後端 middleware 依它判斷是哪個自訂選單）
export const PLATFORM_CUSTOM_MENU_HEADER = 'platform-custom-menuid';
export const ZUSER_PLATFORM_ID = 'dbe66e89-2edc-55b5-9c6e-820110b08d5f';
export const ALERT_HIDE_DURATION = 3000;
// 密碼最小長度（登入與註冊共用）
export const PASSWORD_MIN_LENGTH = 6;

// 通知未讀數快取有效時間（毫秒），避免每次進頁面都呼叫 count API
export const NOTIFICATION_COUNT_CACHE_TTL = 5 * 60 * 1000;

// 側欄清單（模組、客製化選單）存在瀏覽器的快取，頁面開著時每隔多久重抓一次（毫秒）
export const SIDEBAR_LIST_REFRESH_INTERVAL = 24 * 60 * 60 * 1000;
// 通知未讀數快取的 localStorage key
export const NOTIFICATION_COUNT_CACHE_KEY = 'userNotificationCount';

// 平台是否已填付款設定（TapPay）的快取：登入後第一次判斷就記住，6 小時內不重問；重新登入／切換帳號會清掉
export const PAYMENT_ENABLED_CACHE_KEY = 'platformPaymentEnabled';
export const PAYMENT_ENABLED_CACHE_TTL = 6 * 60 * 60 * 1000;

// 短網址轉址頁的路徑前綴（入口依此分流，只載入轉址所需的程式）
export const SHORTEN_URL_PATH_PREFIX = '/x/';
// 短網址轉址頁延遲顯示轉圈的時間（毫秒），轉址夠快時完全不出現載入畫面
export const SHORTEN_URL_LOADING_INDICATOR_DELAY_MS = 400;
// 短網址查詢的後端錯誤代碼
export const SHORTEN_URL_ERROR_CODE = {
  notFound: 4099,
  passwordRequired: 5700,
  passwordIncorrect: 5701,
  expired: 5702,
  maxViewsReached: 5703,
} as const;
// 短網址密碼可嘗試次數，超過後鎖定
export const SHORTEN_URL_MAX_PASSWORD_ATTEMPTS = 3;
// 短網址密碼錯誤過多時的鎖定時間（毫秒）
export const SHORTEN_URL_PASSWORD_LOCK_MS = 5 * 60 * 1000;
// 訪客在短網址頁手動選擇語言的 localStorage key（與全站自動寫入的 i18n 預設值區分）
export const SHORTEN_URL_LANGUAGE_STORAGE_KEY = 'shortenUrlLanguage';
// 短網址頁無法依偏好、瀏覽器或平台決定語言時的後備語言
export const SHORTEN_URL_FALLBACK_LANG = 'en-US';

// 後端回傳的權限不足錯誤代碼（HTTP 401 + code 4007）
export const NO_PERMISSION_ERROR_CODE = 4007;

export default {};

// 方案類型（plans.type）：套餐（有天數的走每月訂閱）/ 點數包（一次性購買）。
export const PLAN_TYPE = {BUNDLE: 'Bundle', CREDIT: 'Credit'} as const;

// 首頁方案價目區（變更方案 / 升級提醒導向）。
export const PRICING_PATH = '/#pricing';

// 公開頁路徑（首頁 CTA / 條款連結）
export const API_DOCUMENT_PATH = '/api-document';
export const POLICY_PATH = '/policy';
export const SIGN_UP_PATH = '/sign-up';

// 版權年份（頁尾 © 年份跟著當年走，不寫死）
export const COPYRIGHT_YEAR = new Date().getFullYear();

// 首頁與公開頁的區段標題字級（theme 的 h4 只有 1.25rem，區段 H2 需統一放大）
export const SECTION_TITLE_SX = {
  fontSize: {xs: '1.5rem', md: '2rem'},
  fontWeight: 700,
};

// 客服信箱（聯絡我們頁顯示與 mailto 共用）
export const SUPPORT_EMAIL = 'support@zzztech.com.tw';

// 後端 USDT 付款維護中的錯誤碼（zzz-users application.PlatformOrderPaymentMaintenance）
export const PAYMENT_MAINTENANCE_CODE = 5951;
/** zusers 後端：信箱或密碼錯誤（application.UserEmailOrPasswordError） */
export const SIGNIN_EMAIL_OR_PASSWORD_ERROR_CODE = 4003;
/** zusers 後端：此平台查無該信箱的帳號（application.UserEmailNotInPlatform，忘記密碼會回） */
export const USER_EMAIL_NOT_IN_PLATFORM_CODE = 4051;
/** zusers 後端：此平台已有該信箱的帳號（application.UserEmailIsExist，註冊會回） */
export const USER_EMAIL_IS_EXIST_CODE = 4002;
/** zusers 後端：平台方案的使用者人數已滿（application.UserPlanQuotaNotEnoughError，註冊會回） */
export const USER_PLAN_QUOTA_NOT_ENOUGH_CODE = 4044;

// 信箱輸入框共用屬性：手機鍵盤不自動把首字大寫、不自動修正拼字，並顯示帶 @ 的信箱鍵盤。
// 登入／註冊／忘記密碼共用；少了它 iOS 會把 demo@… 打成 Demo@…。
export const EMAIL_INPUT_PROPS = {
  autoCapitalize: 'none',
  autoCorrect: 'off',
  spellCheck: false,
  inputMode: 'email',
} as const;

// 手機觸控目標建議最小尺寸（px），登入／註冊／忘記密碼的返回鍵與文字連結共用
export const AUTH_TOUCH_TARGET_PX = 44;

// iOS Safari 對字級小於 16px 的輸入框聚焦時會自動放大畫面，手機寬度下輸入框至少用這個字級
export const IOS_NO_ZOOM_INPUT_FONT_PX = 16;

// 登入／註冊／忘記密碼底部文字連結：用透明 ::after 把可點範圍撐到觸控目標高度，
// 版面與 hover 底線（::before）都不變；連結本身須為 position: relative
export const AUTH_LINK_TOUCH_SX = {
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    height: AUTH_TOUCH_TARGET_PX,
    transform: 'translateY(-50%)',
  },
} as const;

// 底部連結列間距：手機上連結直排，間距加大讓相鄰兩個連結的可點範圍不重疊
export const AUTH_LINK_GRID_SPACING = {xs: 3, sm: 2};

// 自訂選單的權限 scope（與後端 platform-custom-menus 一致）
export const PLATFORM_CUSTOM_MENU_SCOPE = 'platform-custom-menus';

// 後台手機版斷點（與 Dashboard 的 isMobile 一致）
export const MOBILE_MEDIA_QUERY = '@media (max-width: 768px)';

// 後台「輸入找人」下拉（事件操作者、兌換碼推薦人共用 useUserSearch）：使用者可能有幾萬人，
// 至少輸入幾個字才查（避免空字串／單字就掃整個平台）、輸入停頓多久才查、一次最多列幾個
export const USER_SEARCH_MIN_CHARS = 1;
export const USER_SEARCH_DEBOUNCE_MS = 500;
export const USER_SEARCH_LIMIT = 10;

// 使用者列表頁（側欄「使用者」）；能開這頁＝能查使用者清單（usersMe:View，users:View 亦可）
export const DASHBOARD_USERS_LINK = '/dashboard/users';

/**
 * 客製化選單可掛的資料表（與後端 model.CustomFieldEntities 同步）：值＝資料表名稱，各列表頁把自己的值傳給共用表格的 customFieldEntity。
 * labelKey 是該列表頁標題的翻譯鍵，選單設定的下拉選單顯示用。
 */
export const CUSTOM_FIELD_ENTITY = {
  USERS: 'users',
  ROLES: 'roles',
  PLANS: 'plans',
  PLAN_MODULES: 'planModules',
  PLATFORMS: 'platforms',
  PLATFORM_PERMISSIONS: 'platformPermissions',
  PLATFORM_ORDERS: 'platformOrders',
  PLATFORM_CONTACTS: 'platformContacts',
  PLATFORM_DEVICES: 'platformDevices',
  PLATFORM_EMAILS: 'platformEmails',
  PLATFORM_ADDRESSES: 'platformAddresses',
  PLATFORM_VOICES: 'platformVoices',
  PLATFORM_FACES: 'platformFaces',
  PLATFORM_REDEMPTION_CODES: 'platformRedemptionCodes',
  SHORTEN_URLS: 'shortenUrls',
  VERIFICATIONS: 'verifications',
  USER_NOTIFICATIONS: 'userNotifications',
  USER_AI_MESSAGES: 'userAIMessages',
} as const;

export const CUSTOM_FIELD_ENTITY_OPTIONS: {entity: string; labelKey: string}[] = [
  {entity: CUSTOM_FIELD_ENTITY.USERS, labelKey: 'dashboardMenuUser'},
  {entity: CUSTOM_FIELD_ENTITY.ROLES, labelKey: 'dashboardMenuRole'},
  {entity: CUSTOM_FIELD_ENTITY.PLANS, labelKey: 'dashboardMenuPlan'},
  {entity: CUSTOM_FIELD_ENTITY.PLAN_MODULES, labelKey: 'dashboardMenuPlanModule'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORMS, labelKey: 'dashboardMenuPlatform'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_PERMISSIONS, labelKey: 'dashboardMenuPermission'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_ORDERS, labelKey: 'dashboardMenuPlatformOrder'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_CONTACTS, labelKey: 'dashboardMenuPlatformContact'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_DEVICES, labelKey: 'dashboardPlatformDevice'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_EMAILS, labelKey: 'dashboardPlatformEmail'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_ADDRESSES, labelKey: 'dashboardMenuPlatformAddress'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_VOICES, labelKey: 'dashboardMenuAIPlatformVoice'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_FACES, labelKey: 'dashboardMenuAIPlatformFace'},
  {entity: CUSTOM_FIELD_ENTITY.PLATFORM_REDEMPTION_CODES, labelKey: 'dashboardPlatformRedemptionPageTitle'},
  {entity: CUSTOM_FIELD_ENTITY.SHORTEN_URLS, labelKey: 'dashboardMenuShortenUrl'},
  {entity: CUSTOM_FIELD_ENTITY.VERIFICATIONS, labelKey: 'dashboardMenuVerification'},
  {entity: CUSTOM_FIELD_ENTITY.USER_NOTIFICATIONS, labelKey: 'dashboardMenuUserNotification'},
  {entity: CUSTOM_FIELD_ENTITY.USER_AI_MESSAGES, labelKey: 'dashboardMenuUserMessage'},
];

// 使用者通知類型（對應後端 model.UserNotificationType）
export const USER_NOTIFICATION_TYPE = {SYSTEM: 'SYSTEM'} as const;

// 權限動作（對應後端 model.PermissionAction）
export const PERMISSION_ACTION = {
  VIEW: 'View',
  CREATE: 'Create',
  EDIT: 'Edit',
  DELETE: 'Delete',
} as const;
export type PermissionActionName =
  (typeof PERMISSION_ACTION)[keyof typeof PERMISSION_ACTION];

// 自己的權限清單快取多久（同一頁的頁面與表格共用一次請求；角色調整後最慢這麼久生效，重新整理立即生效）
export const MY_PERMISSIONS_CACHE_TTL = 30 * 1000;

// 後台「最近事件」即時推播的 WebSocket 路徑（後端 zusers /ws/v1/event）
export const EVENT_WS_PATH = '/ws/v1/event';
// WebSocket 握手帶 token 的子協定名稱：Sec-WebSocket-Protocol 送 "bearer, <token>"（瀏覽器不能自訂 Authorization 標頭）
export const WS_AUTH_SUBPROTOCOL = 'bearer';
// WebSocket 握手帶平台 id 的 query 參數
export const WS_PLATFORM_ID_QUERY = 'platformId';
// 事件推播斷線後第一次重連等多久（毫秒），之後每次加倍到上限
export const EVENT_WS_RECONNECT_DELAY_MS = 1000;
export const EVENT_WS_RECONNECT_MAX_DELAY_MS = 30 * 1000;
// 事件推播訊息的 event 欄位值（後端 dto.WsEventRecord）
export const EVENT_WS_RECORD_EVENT = 'eventRecord';
